export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: '작업구분' }, { name: '협력업체명' }, { name: '공종명' }, { name: '작업일자' }, { name: '작성자' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContentStringList(func.getContent(value).typeTitleList) // 작업구분
      case 2: return func.getContent(value).companyName // 협력업체명
      case 3: return func.getContent(value).inputC_2 // 공종명
      case 4: return func.getContent(value).inputC_3 // 작업일자
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '사업장명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
    case '작업구분': return ['content$body.typeTitleList*%[:default_skw]%']
    case '협력업체명': return ['content$body.companyName*%[:default_skw]%']
    case '공종명': return ['content$body.inputC_2*%[:default_skw]%']
    case '작업일자': return ['content$body.inputC_3*%[:default_skw]%']
    case '작성자': return ['content$body.stdInfo.writer_name*%[:default_skw]%']
    }

    return []
  },
}
